import React from 'react'
import cx from 'classnames'

import { Button } from 'components/shared/Button/Button'

import styles from './AuthButton.module.scss'

export const AuthButton = ({ className, label, variant, onClick }) => (
  <Button
    className={cx(styles.button, styles.variant, {
      [styles[variant]]: Boolean(variant),
      [className]: Boolean(className),
    })}
    color="primary"
    size="medium"
    {...{ label, variant, onClick }}
  />
)
